export default {
  "appName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["LDev"])},
  "copyright": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Copyright © "])},
  "email": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email address"])},
  "login": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Login"])},
  "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])}
}